module.exports = __webpack_public_path__ + "img/4valvulas.638cf85f.jpg";